<template>
  <div v-animate-css.click="'tada'" @click="doCopy(rgbToHex(swatch.rgb).substring(1))">
    <div
      :class="[isSmall ? 'color-box-sm' : 'color-box', 'border']"
      :style="{ background: rgbToHex(swatch.rgb) }"
    >
      <div class="color-box-inside">
        <fitty class="color-box-title">
          <template v-slot:content>
            <span
              v-if="message"
              class="text-uppercase color-title"
              :style="{color: getFontColor(swatch.rgb)}"
            >{{ message }}</span>

            <span
              v-else
              class="text-uppercase color-title"
              :style="{color: getFontColor(swatch.rgb)}"
            >{{ rgbToHex(swatch.rgb) }}</span>
          </template>
        </fitty>
      </div>
    </div>
  </div>
</template>

<script>
// Import Vibrant
import * as Vibrant from "node-vibrant";

export default {
  name: "colorBox",
  props: ["swatch", "isSmall"],
  data() {
    return {
      message: null
    };
  },
  methods: {
    rgbToHex(rgb) {
      let hex = Vibrant.Util.rgbToHex(rgb[0], rgb[1], rgb[2]);
      return hex;
    },
    getFontColor(rgb) {
      return rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114 > 186
        ? "#000"
        : "#fff";
    },
    doCopy(msg) {
      let self = this;
      self.$copyText(msg).then(() => {
        self.message = "copied!";
        setTimeout(() => {
          self.message = null;
        }, 1000);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.color-box {
  width: 15vh;
  max-width: 80%;
  padding-top: 15vh;
  position: relative;
  margin: 0 auto;
  border-radius: 0.5em;
  cursor: pointer;
}
.color-box-sm {
  width: 80%;
  padding-top: 30%;
  position: relative;
  margin: 0 auto;
  border-radius: 0.2em;
  cursor: pointer;
}
.color-box-inside {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
}
.color-title {
  font-family: "Share Tech Mono", monospace;
}
</style>
